"use strict";
/* Copyright (c) 2023 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStartOperations = void 0;
/* tslint:disable:no-console */
var AnalyticsConstants_1 = require("./AnalyticsConstants");
var EventQueue_1 = require("./eventqueue/EventQueue");
var AppStartOperations = /** @class */ (function () {
    function AppStartOperations() {
    }
    AppStartOperations.addEventToQueue = function (payload) {
        var finalPayload = payload.merge(AppStartOperations.globals);
        AppStartOperations.eventQueue.add(finalPayload);
        if (!AppStartOperations.noConsoleLog) {
            console.log(AppStartOperations.TAG, finalPayload.toSendable());
        }
    };
    AppStartOperations.upload = function (transport) {
        if (AppStartOperations.eventQueue.hasNext()) {
            transport
                .send(AppStartOperations.eventQueue.next().merge(AppStartOperations.globals))
                .then(function () {
                AppStartOperations.eventQueue.remove();
            })
                .catch(function (err) {
                if (err) {
                    AppStartOperations.eventQueue.remove();
                }
            })
                .finally(function () {
                AppStartOperations.upload(transport);
            });
        }
    };
    AppStartOperations.log = function (data) {
        data.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.OPERATIONS);
        var finalPayload = data.merge(AppStartOperations.globals);
        AppStartOperations.addEventToQueue(finalPayload);
    };
    AppStartOperations.setGlobals = function (params) {
        AppStartOperations.globals = params;
    };
    AppStartOperations.setEventQueueSize = function (size) {
        AppStartOperations.eventQueue.setSize(size);
    };
    AppStartOperations.noConsole = function () {
        AppStartOperations.noConsoleLog = true;
    };
    AppStartOperations.TAG = 'AppStartOperations';
    AppStartOperations.eventQueue = new EventQueue_1.EventQueue();
    AppStartOperations.noConsoleLog = false;
    return AppStartOperations;
}());
exports.AppStartOperations = AppStartOperations;
